export interface PlacementSpan {
  readonly fromMm: number;
  readonly toMm: number;
  /** 이 조각에서 컴포넌트 로컬 x = 0 이 놓이는 창 x. 로컬 x = 창 x − originMm. */
  readonly originMm: number;
}

/**
 * 배치를 둘레 2W 로 감아 앞면 창 [0, W] 에 보이는 조각을 돌려준다(Phase 5 Q6, 엔진 visibleArcSegments 와 같은 구간).
 * 꼬리(감겨서 앞으로 온 부분)가 먼저, 머리가 뒤다. 폭 0 조각은 뺀다. 그리기와 히트테스트가 같은 조각을 쓴다.
 */
export const wrappedPlacementSpans = (
  xMm: number,
  widthMm: number,
  frameWidthMm: number,
): readonly PlacementSpan[] => {
  if (!Number.isFinite(xMm) || !Number.isFinite(widthMm) || widthMm <= 0 || !(frameWidthMm > 0))
    return [];
  const circumference = 2 * frameWidthMm;
  const span = Math.min(widthMm, circumference);
  const start = ((xMm % circumference) + circumference) % circumference;
  const candidates = [start - circumference, start];
  return candidates.flatMap((originMm) => {
    const fromMm = Math.max(0, originMm);
    const toMm = Math.min(frameWidthMm, originMm + span);
    return toMm > fromMm ? [{ fromMm, toMm, originMm }] : [];
  });
};
